// Third party
import { combineEpics } from "redux-observable";

// Project
import attachment from "./attachment";
import messageLoadingErredEpic from "./messageLoadingErredEpic";

export default combineEpics(attachment, messageLoadingErredEpic);
